/**
 * 滚动揭示动画
 * 合并入场动画（scroll-animations）+ 图片加载动画（image-animation），统一 IntersectionObserver
 */
export function initScrollReveal() {
  // 尊重用户减少动画偏好
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('.animate-on-scroll').forEach(el => el.classList.add('is-visible'));
    return;
  }

  // 降级：不支持 IntersectionObserver 时直接显示
  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('.animate-on-scroll').forEach(el => el.classList.add('is-visible'));
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');

        // 图片动画：添加 animate-image 类触发 CSS 动画
        if (entry.target.classList.contains('image-animation')) {
          entry.target.classList.add('animate-image');
        }

        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px',
  });

  // 观察 .animate-on-scroll 元素（入场动画）
  document.querySelectorAll('.animate-on-scroll').forEach(el => observer.observe(el));

  // 观察需要图片动画的图片（排除 banner、logo 和已有动画控制的）
  document.querySelectorAll(
    'img:not([src*="banner"]):not(.logo img):not(.animate-image)'
  ).forEach(img => {
    // 跳过父容器已由 animate-on-scroll 控制的图片
    if (img.closest('.animate-on-scroll')) return;

    img.classList.add('image-animation');
    observer.observe(img);
  });

  // 特别处理产品卡片图片，确保动画效果
  document.querySelectorAll('.product-card-link .product-image img').forEach(img => {
    if (img.classList.contains('animate-image')) return;
    if (img.closest('.animate-on-scroll')) return;

    img.classList.add('image-animation');
    observer.observe(img);
  });
}
